<template>
  <div
    class="s-plan-features-comp s-transition-03"
    :class="[{'start' : planSubscribed === 'start'},
             {'subscribed' : isSubscribed},
             {'selected' : isSelected},
             {'show-plan-limits' : showPlanLimits},
             {'in-modal' : inModal},
             togglePrice ? 'price-annually' : 'price-monthly',
            ]">

    <!-- Parent - Heading -->
    <div class="s-plan-features-heading">
      <section class="s-plan-features-subscribed-col">
        <s-icon class="subscribed-plan-icon" :icon-font="planSubscribed === 'start' || planSubscribed === 'trial' ? 's-icon-clock-thin' : ''" :icon-image="planSubscribed !== 'trial' ? planIconImagePath(planSubscribed) : ''"></s-icon>
      </section>

      <section class="s-plan-features-name-col">
        <span v-if="!showPlanLimits">{{  $t('plans-container.features-title') }}</span>
        <span v-else>{{ $t('plans-container.available-features-title') }}</span>
      </section>

      <section class="s-plan-features-selected-col">
        <s-icon class="selected-plan-icon" :icon-image="planIconImagePath(planSelected)"></s-icon>
      </section>
    </div>

    <!-- Parent - Feature list -->
    <div class="s-plan-feature-list s-scroll">
      <section class="s-plan-features-subscribed-col">
        <ul>
          <li v-for="(feature, index) in featuresSubscribed" :key="feature.key" :class="showPlanLimitsItem(index)">
            <s-icon v-if="feature.planDetail == 'ok'"
                    class="subscribed-plan-icon"
                    :class="[ planSubscribed, {'disabled' : feature.planDetail === '-' }]"
                    :icon-font="feature.planDetail == 'ok' ? 's-icon-ok' : '' "
                    circle></s-icon>
            <span v-if="feature.planDetail" class="subscribed-plan-detail">{{feature.planDetail == 'ok' ? '' : feature.planDetail }}</span>
          </li>
        </ul>
      </section>

      <section class="s-plan-features-name-col">
        <ul>
          <li v-for="(feature, index) in featuresNames" :key="feature.key" :class="showPlanLimitsItem(index)">
            <span class="s-plan-features-name">{{ feature.name }}</span>
          </li>
        </ul>
      </section>

      <section v-if="!showPlanLimits" class="s-plan-features-selected-col">
        <ul>
          <li v-for="feature in featuresSelected" :key="feature.key">
            <s-icon v-if="feature.planDetail == 'ok' && planSelected"
                    class="selected-plan-icon"
                    :class="[ planSelected, {'disabled' : feature.planDetail === '-' }]"
                    :icon-font="feature.planDetail == 'ok' ? 's-icon-ok' : '' "
                    circle></s-icon>
            <span v-if="feature.planDetail && planSelected" class="subscribed-plan-detail">{{feature.planDetail == 'ok' ? '' : feature.planDetail }}</span>
          </li>
        </ul>
      </section>

      <!-- TODO: finish this design showing feature limits and resources    -->
      <section v-if="showPlanLimits" class="s-plan-feature-limits-progressbar-col">
        <ul>
          <li v-for="(feature, index) in featuresSubscribed" :key="feature.key" :class="showPlanLimitsItem(index)">
            <!-- Group -->
            <div class="s-plan-feature-limits-progressbar s-flex">
              <span class="s-margin-r-auto">#</span>
              <span class="">##</span>
            </div>

            <!-- TODO: Link up DATA -->
            <s-progress-bar
              class="s-progress-bar-planlimits"
              :class="[ {'s-progress-bar-blue' : planLimitUsage > 10},
                          {'s-progress-bar-green' : planLimitUsage > 25},
                          {'s-progress-bar-orange' : planLimitUsage > 50},
                          {'s-progress-bar-red' : planLimitUsage > 75},
                        ]"
              :progress-bar-width="planLimitUsage"
            ></s-progress-bar>
          </li>
        </ul>

      </section>

    </div>

    <!-- TODO: finish this design showing feature limits and resources    -->
    <!-- Parent - Feature Limits -->
    <div class="s-plan-feature-limits s-hide">
      <ul>

        <li v-for="(feature, index) in featuresLimits" :key="feature.key" >
          <section class="s-plan-features-subscribed-col">
            <s-icon v-if="feature.planDetail == 'ok'"
                    class="subscribed-plan-icon"
                    :class="[{'disabled' : feature.planDetail === '-' }]"
                    :icon-font="feature.planDetail === 'ok' ? 's-icon-ok' : '' "
                    circle></s-icon>
            <span v-if="feature.planDetail" class="subscribed-plan-detail">{{feature.planDetail == 'ok' ? '' : feature.planDetail }}</span>
          </section>

          <section class="s-plan-features-name-col">
            <span class="s-plan-features-name">{{ featuresNames[index].name }}</span>
          </section>

          <section class="s-plan-feature-limits-progressbar-col">

            <!-- Group -->
            <div class="s-plan-feature-limits-progressbar s-flex">
              <span class="s-margin-r-auto">#</span>
              <span class="">##</span>
            </div>

            <!-- TODO: Link up DATA -->
            <s-progress-bar
              class="s-progress-bar-planlimits"
              :class="[ {'s-progress-bar-blue' : planLimitUsage > 10},
                          {'s-progress-bar-green' : planLimitUsage > 25},
                          {'s-progress-bar-orange' : planLimitUsage > 50},
                          {'s-progress-bar-red' : planLimitUsage > 75},
                        ]"
              :progress-bar-width="planLimitUsage"
            ></s-progress-bar>
          </section>

        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import SIcon from "@/components/SIcon.vue";
import SProgressBar from "@/components/SProgressBar.vue";


export default {
  components: {
    SIcon,
    SProgressBar,

  },
  props: {
    planSubscribed: String,
    planSelected: String,
    isSubscribed: {
      type: Boolean,
      default: false,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    showPlanLimits: {
      type: Boolean,
      default: false,
    },
    inModal: {
      type: Boolean,
      default: false,
    },
    togglePrice: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // featuresTemplate: [
      //   {  planDetail: 'ok', name: 'Plan Name', },
      //   {  planDetail: 'ok', name: 'Price', },
      //   {  planDetail: 'ok', name: this.$t('plans-container.features.free-storage-title')},
      //   {  planDetail: 'ok', name: this.$t('plans-container.features.storage-title')},
      //   {  planDetail: 'ok', name: this.$t('plans-container.features.hd-title')},
      //   {  planDetail: 'ok', name: this.$t('plans-container.features.fhd-title')},
      //   {  planDetail: 'ok', name: this.$t('plans-container.features.4k-title')},
      //   {  planDetail: 'ok', name: this.$t('plans-container.features.add-on-title')},
      //   {  planDetail: 'ok', name: this.$t('plans-container.features.rss-title')},
      //   {  planDetail: 'ok', name: this.$t('plans-container.features.rss-auto-title')},
      //   {  planDetail: 'ok', name: this.$t('plans-container.features.storage-ext-title')},
      //   {  planDetail: 'ok', name: this.$t('plans-container.features.links-title')},
      //   {  planDetail: 'ok', name: this.$t('plans-container.features.antivirus-title')},
      //   {  planDetail: 'ok', name: this.$t('plans-container.features.seedr-ultra-title')},
      //   {  planDetail: 'ok', name: this.$t('plans-container.features.ftp-title')},
      //   {  planDetail: 'ok', name: this.$t('plans-container.features.webdav-title')},
      //   {  planDetail: 'ok', name: this.$t('plans-container.features.1-1-title')},
      //   {  planDetail: 'ok', name: this.$t('plans-container.features.2-1-title')},
      //   {  planDetail: 'ok', name: this.$t('plans-container.features.5-1-title')},
      //   {  planDetail: 'ok', name: this.$t('plans-container.features.streaming-title')},
      //   {  planDetail: 'ok', name: this.$t('plans-container.features.8-down-title')},
      //   {  planDetail: 'ok', name: this.$t('plans-container.features.trackers-title')},
      // ],
      featuresNames: [
        // { name: 'Plan Name', },
        // { name: 'Price', },
        { name: this.$t('plans-container.features.free-storage-title')},
        { name: this.$t('plans-container.features.storage-title')},
        { name: this.$t('plans-container.features.hd-title')},
        { name: this.$t('plans-container.features.fhd-title')},
        { name: this.$t('plans-container.features.4k-title')},
        { name: this.$t('plans-container.features.add-on-title')},
        { name: this.$t('plans-container.features.rss-title')},
        { name: this.$t('plans-container.features.rss-auto-title')},
        { name: this.$t('plans-container.features.storage-ext-title')},
        { name: this.$t('plans-container.features.links-title')},
        { name: this.$t('plans-container.features.antivirus-title')},
        { name: this.$t('plans-container.features.seedr-ultra-title')},
        { name: this.$t('plans-container.features.ftp-title')},
        { name: this.$t('plans-container.features.webdav-title')},
        { name: this.$t('plans-container.features.1-1-title')},
        { name: this.$t('plans-container.features.2-1-title')},
        { name: this.$t('plans-container.features.5-1-title')},
        { name: this.$t('plans-container.features.streaming-title')},
        { name: this.$t('plans-container.features.8-down-title')},
        { name: this.$t('plans-container.features.trackers-title')},
      ],
      // NOTE: 'name' in lists bellow are not working they are only for comfort of applying planDetail to correct list name
      featuresTrial: [
        // {  planDetail: 'Trial', name: 'Plan Name', },
        // {  planDetail: 'Free', name: 'Price', },
        {  planDetail: '5GB',   name: 'Free 2gb Storage'},
        {  planDetail: '-',     name: 'Storage'},
        {  planDetail: '-',     name: 'HD'},
        {  planDetail: '-',     name: 'FHD'},
        {  planDetail: '-',     name: '4K'},
        {  planDetail: 'ok',    name: 'Adds on'},
        {  planDetail: 'ok',    name: 'RSS'},
        {  planDetail: '-',     name: 'RSS Automation'},
        {  planDetail: '-',     name: 'Storage extension'},
        {  planDetail: '1',     name: 'Links at the time'},
        {  planDetail: '-',     name: 'Antivirus scan'},
        {  planDetail: '-',     name: 'Seedr Ultra© Download Servers'},
        {  planDetail: '-',     name: 'High-Speed FTP'},
        {  planDetail: '-',     name: 'WebDAV Drive & High-Speed FTP'},
        {  planDetail: '-',     name: '1:1 Ratio or 12h'},
        {  planDetail: '-',     name: '2:1 Ratio or 24 Hours'},
        {  planDetail: '-',     name: '5:1 Ratio or 5 Days'},
        {  planDetail: '-',     name: 'HD Streaming'},
        {  planDetail: '-',     name: '8 Parallel Download Connections'},
        {  planDetail: '-',     name: 'Private Trackers Suppor'},
      ],
      featuresLite: [
        // {  planDetail: 'Lite', name: 'Plan Name', },
        // {  planDetail: '$2', name: 'Price', },
        {  planDetail: 'ok',    name: 'Free 2gb Storage'},
        {  planDetail: '30GB',  name: 'Storage'},
        {  planDetail: '-',     name: 'HD'},
        {  planDetail: '-',     name: 'FHD'},
        {  planDetail: '-',     name: '4K'},
        {  planDetail: 'ok',    name: 'Adds on'},
        {  planDetail: 'ok',    name: 'RSS'},
        {  planDetail: '-',     name: 'RSS Automation'},
        {  planDetail: '1GB',   name: 'Storage extension'},
        {  planDetail: '2',     name: 'Links at the time'},
        {  planDetail: '-',     name: 'Antivirus scan'},
        {  planDetail: '-',     name: 'Seedr Ultra© Download Servers'},
        {  planDetail: '-',     name: 'High-Speed FTP'},
        {  planDetail: '-',     name: 'WebDAV Drive & High-Speed FTP'},
        {  planDetail: '-',     name: '1:1 Ratio or 12h'},
        {  planDetail: '-',     name: '2:1 Ratio or 24 Hours'},
        {  planDetail: '-',     name: '5:1 Ratio or 5 Days'},
        {  planDetail: '-',     name: 'HD Streaming'},
        {  planDetail: '-',     name: '8 Parallel Download Connections'},
        {  planDetail: '-',     name: 'Private Trackers Suppor'},
      ],
      featuresBasic: [
        // {  planDetail: 'Basic', name: 'Plan Name', },
        // {  planDetail: '$6.95', name: 'Price', },
        {  planDetail: 'ok',    name: 'Free 2gb Storage'},
        {  planDetail: '30gb',  name: 'Storage'},
        {  planDetail: '-',     name: 'HD'},
        {  planDetail: '-',     name: 'FHD'},
        {  planDetail: '-',     name: '4K'},
        {  planDetail: 'ok',    name: 'Adds on'},
        {  planDetail: 'ok',    name: 'RSS'},
        {  planDetail: 'ok',    name: 'RSS Automation'},
        {  planDetail: '2GB',   name: 'Storage extension'},
        {  planDetail: '2',     name: 'Links at the time'},
        {  planDetail: 'ok',    name: 'Antivirus scan'},
        {  planDetail: 'ok',    name: 'Seedr Ultra© Download Servers'},
        {  planDetail: '-',     name: 'High-Speed FTP'},
        {  planDetail: '-',     name: 'WebDAV Drive & High-Speed FTP'},
        {  planDetail: 'ok',    name: '1:1 Ratio or 12h'},
        {  planDetail: '-',     name: '2:1 Ratio or 24 Hours'},
        {  planDetail: '-',     name: '5:1 Ratio or 5 Days'},
        {  planDetail: 'ok',    name: 'HD Streaming'},
        {  planDetail: '-',     name: '8 Parallel Download Connections'},
        {  planDetail: '-',     name: 'Private Trackers Suppor'},
      ],
      featuresPro: [
        // {  planDetail: 'Pro', name: 'Plan Name', },
        // {  planDetail: '$9.95', name: 'Price', },
        {  planDetail: 'ok',    name: 'Free 2gb Storage'},
        {  planDetail: '100GB', name: 'Storage'},
        {  planDetail: 'ok',    name: 'HD'},
        {  planDetail: '-',     name: 'FHD'},
        {  planDetail: '-',     name: '4K'},
        {  planDetail: 'ok',    name: 'Adds on'},
        {  planDetail: 'ok',    name: 'RSS'},
        {  planDetail: 'ok',    name: 'RSS Automation'},
        {  planDetail: '5GB',   name: 'Storage extension'},
        {  planDetail: '5',     name: 'Links at the time'},
        {  planDetail: 'ok',    name: 'Antivirus scan'},
        {  planDetail: 'ok',    name: 'Seedr Ultra© Download Servers'},
        {  planDetail: 'ok',    name: 'High-Speed FTP'},
        {  planDetail: '-',     name: 'WebDAV Drive & High-Speed FTP'},
        {  planDetail: 'ok',    name: '1:1 Ratio or 12h'},
        {  planDetail: 'ok',    name: '2:1 Ratio or 24 Hours'},
        {  planDetail: '-',     name: '5:1 Ratio or 5 Days'},
        {  planDetail: 'ok',    name: 'HD Streaming'},
        {  planDetail: '-',     name: '8 Parallel Download Connections'},
        {  planDetail: '-',     name: 'Private Trackers Suppor'},
      ],
      featuresMaster: [
        // {  planDetail: 'Master', name: 'Plan Name', },
        // {  planDetail: '$19.95', name: 'Price', },
        {  planDetail: 'ok',    name: 'Free 2gb Storage'},
        {  planDetail: '1TB',   name: 'Storage'},
        {  planDetail: 'ok',    name: 'HD'},
        {  planDetail: 'ok',    name: 'FHD'},
        {  planDetail: 'ok',    name: '4K'},
        {  planDetail: 'ok',    name: 'Adds on'},
        {  planDetail: 'ok',    name: 'RSS'},
        {  planDetail: 'ok',    name: 'RSS Automation'},
        {  planDetail: '10GB',  name: 'Storage extension'},
        {  planDetail: '25',    name: 'Links at the time'},
        {  planDetail: 'ok',    name: 'Antivirus scan'},
        {  planDetail: 'ok',    name: 'Seedr Ultra© Download Servers'},
        {  planDetail: 'ok',    name: 'High-Speed FTP'},
        {  planDetail: 'ok',    name: 'WebDAV Drive & High-Speed FTP'},
        {  planDetail: 'ok',    name: '1:1 Ratio or 12h'},
        {  planDetail: 'ok',    name: '2:1 Ratio or 24 Hours'},
        {  planDetail: 'ok',    name: '5:1 Ratio or 5 Days'},
        {  planDetail: 'ok',    name: 'HD Streaming'},
        {  planDetail: 'ok',    name: '8 Parallel Download Connections'},
        {  planDetail: 'ok',    name: 'Private Trackers Suppor'},
      ],
    };
  },
  computed: {
    planIconImagePath() {
      return (name) => {
        if (name === 'lite') return 'SVG/plan_lite_logo_SVG.svg';
        if (name === 'basic') return 'SVG/plan_basic_logo_SVG.svg';
        if (name === 'pro') return 'SVG/plan_pro_logo_SVG.svg';
        if (name === 'master') return 'SVG/plan_master_logo_SVG.svg';
      };
    },
    featuresSubscribed() {
      return this.features(this.planSubscribed)
    },
    featuresSelected() {
      return this.features(this.planSelected)
    },
    featuresLimits() {
      return this.features(this.planName || this.planSelected)
    },
    // TODO: Link up DATA
    planLimitUsage() {
      return 75;
    },
  },
  methods: {
    features(planNameList) {
      if (planNameList === 'start') return this.featuresTrial
      if (planNameList === 'trial') return this.featuresTrial
      if (planNameList === 'lite') return this.featuresLite
      if (planNameList === 'basic') return this.featuresBasic
      if (planNameList === 'pro') return this.featuresPro
      if (planNameList === 'master') return this.featuresMaster
    },
    showPlanLimitsItem(index) {
      if (this.featuresSubscribed[index].planDetail === '-' && this.showPlanLimits) return 's-hide'
    }
  },
};
</script>
